<template lang="">
  <div class="contents">
    <div class="signUp_wrap">
        <div class="signUp_head">
            <h5 class="tit">회원가입</h5>
            <ul class="step">
                <li>01. 약관동의</li>
                <li class="on">02. 정보입력</li>
                <li>03. 가입완료</li>
            </ul>
        </div>
        <div class="signUp_body">
            <div class="tbl_wrap">
                <table class="info_tbl">
                    <tbody>
                        <tr>
                            <th>
                                <span>*</span>이름
                            </th>
                            <td>
                                <div class="wrapper">
                                    <input type="text" placeholder="블러썸" v-model="name" :readonly="verified">
                                    <!-- <span class="name">블러썸</span> -->
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span>*</span>아이디
                            </th>
                            <td>
                                <div class="wrapper">
                                    <div class="input_wrap">
                                        <input type="text" placeholder="6~16자 이내의 영문 대/소문자, 숫자, 특수문자(_),(-)만 사용 가능" v-model="username">
                                        <button @click="checkDuplicate">중복확인</button>
                                    </div>
                                </div>
                                <span class="phrase" v-if="!usernameCheck">아이디 중복확인을 해주세요.</span>
                                <span class="phrase" v-else>사용 가능한 아이디입니다.</span>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span>*</span>비밀번호
                            </th>
                            <td>
                                <div class="wrapper">
                                    <div class="input_wrap">
                                        <input type="password" placeholder="8~16자 이내의 영문 대/소문자, 숫자, 특수문자중 2가지 이상 조합하여 사용 가능" v-model="pwd" @input="validatePassword">
                                        <span class="phrase">{{ passwordError }}</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span>*</span>비밀번호 확인
                            </th>
                            <td>
                                <div class="wrapper">
                                    <div class="input_wrap">
                                        <input type="password" placeholder="비밀번호 확인을 위해 한번 더 입력" v-model="pwdCheck">
                                        <span class="phrase" v-if="pwd !== pwdCheck">비밀번호가 일치하지 않습니다.</span>
                                        <span class="phrase" v-else>비밀번호가 일치합니다.</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span>*</span>생년월일
                            </th>
                            <td>
                                <div class="wrapper">
                                    <div class="input_wrap">
                                        <SelectList v-model="birthday.year" :options="yearOptions" unit="년" selectClass="select_box type2"/>
                                    </div>
                                    <div class="input_wrap">
                                        <SelectList v-model="birthday.month" :options="monthOptions" unit="월" selectClass="select_box"/>
                                    </div>
                                    <div class="input_wrap">
                                        <SelectList v-model="birthday.day" :options="getDayOptions(birthday.year, birthday.month)" unit="일" selectClass="select_box"/>
                                    </div>
                                    <div class="form_wrap">
                                        <label for="solar" class="radio_wrap">
                                            <input type="radio" id="solar" name="birth" v-model="birthday.calendar" :value="'solar'">
                                            <span>양력</span>
                                        </label>
                                        <label for="lunar" class="radio_wrap">
                                            <input type="radio" id="lunar" name="birth" v-model="birthday.calendar" :value="'lunar'">
                                            <span>음력</span>
                                        </label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                주소
                            </th>
                            <td>
                                <div class="wrapper">
                                    <div class="input_wrap">
                                        <input type="text" class="address" v-model="zonecode" disabled>
                                        <button @click="openPostcode">우편번호 검색</button>
                                    </div>
                                </div>
                                <div class="wrapper">
                                    <div class="input_wrap">
                                        <input type="text" class="address2" v-model="roadAddress" disabled>
                                        <input type="text" class="address" v-model="detailAddress">
                                    </div>
                                </div>
                                <span class="phrase">* 이벤트, 경품 당첨 시 기본 배송지로 전달 됩니다.</span>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span>*</span>전화번호
                            </th>
                            <td>
                                <div class="wrapper">
                                    <input type="text" class="num" v-model="telNum.telFirst">
                                    <span>-</span>
                                    <input type="text" class="num" v-model="telNum.telMiddle">
                                    <span>-</span>
                                    <input type="text" class="num" v-model="telNum.telLast">
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span>*</span>휴대폰
                            </th>
                            <td>
                                <div class="wrapper">
                                    <div class="input_wrap">
                                        <input type="text" class="num" v-model="phoneNum.phoneFirst" :readonly="verified">
                                        <span>-</span>
                                        <input type="text" class="num" v-model="phoneNum.phoneMiddle" :readonly="verified">
                                        <span>-</span>
                                        <input type="text" class="num" v-model="phoneNum.phoneLast" :readonly="verified">
                                        <button @click="vertifyPhone">본인인증</button>
                                        <span v-if="verified" class="phrase">본인인증 완료</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span>*</span>이메일
                            </th>
                            <td>
                                <div class="wrapper">
                                    <input type="text" class="mail" v-model="email.emailFirst">
                                    <span>@</span>
                                    <input type="text" class="mail" v-model="email.emailLast" :disabled="emailSelf !== '직접입력'">
                                    <SelectList v-model="emailSelf" :options="emailOptions" unit="" selectClass="select_box"/>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span>*</span>마케팅 수신 동의
                            </th>
                            <td>
                                <div class="wrapper">
                                    <div class="form_wrap">
                                        <label for="sms" class="radio_wrap">
                                            <input type="radio" :true-value="'Y'" :false-value="'N'" :value="'Y'" v-model="marketing.sms" @click="toggleRadio('sms')">
                                            <span>문자 수신</span>
                                        </label>
                                        <label for="email" class="radio_wrap">
                                            <input type="radio" :true-value="'Y'" :false-value="'N'" :value="'Y'" v-model="marketing.email" @click="toggleRadio('email')">
                                            <span>이메일 수신</span>
                                        </label>
                                    </div>
                                </div>
                                <ul>
                                    <li>이메일 및 SMS 수신동의 시, Blossom Logos에서 제공되는 다양한 할인 혜택과 이벤트 및 기획전</li>
                                    <li>구매정보 및 서비스 주요 정책 관련 내용은 수신 동의 여부와 관계없이 발송됩니다.</li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="btn_wrap">
                <button type="button" class="btn_join" @click="signup">회원가입</button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { mapActions } from 'vuex';
import SelectList from '@/components/common/SelectList.vue';
import env from '@/env';
import PortOne from "@portone/browser-sdk/v2";

const accountModule = 'accountModule'

export default {
  components: {
    SelectList
  },

  props: {
    marketing: {
      type: Object
    }
  },

  data () {
    return {
      name: '',
      username: '',
      pwd: '',
      pwdCheck: '',
      birthday: {
        year: new Date().getFullYear(),
        month: '01',
        day: '01',
        calendar: 'solar'
      },
      zonecode: '',
      roadAddress: '',
      detailAddress: '',
      telNum: {
        telFirst: '',
        telMiddle: '',
        telLast: ''
      },
      phoneNum: {
        phoneFirst: '',
        phoneMiddle: '',
        phoneLast: ''
      },
      email: {
        emailFirst: '',
        emailLast: ''
      },
      emailSelf: '직접입력',

      usernameCheck: false,

      yearOptions: this.getYearOptions(),
      monthOptions: this.getMonthOptions(),
      dayOptions: [],
      emailOptions: [
        '직접입력',
        'naver.com',
        'gmail.com'
      ],

      marketingAgreement: this.marketing,
      passwordError: '',
      verified: false
    }
  },

  methods: {
    ...mapActions(accountModule, [
      'requestCheckUsername',
      'requestSignup'
    ]),

    getYearOptions() {
        const currentYear = new Date().getFullYear();
        return Array.from({ length: 70 }, (_, i) => String(currentYear - i));
    },

    getMonthOptions() {
        return Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'));
    },

    getDayOptions(year, month) {
        const daysInMonth = new Date(year, month, 0).getDate();
        return Array.from({ length: daysInMonth }, (_, i) => String(i + 1).padStart(2, '0'));
    },

    nextPage() {
      this.$emit('nextPage')
    },

    openPostcode() {
      new window.daum.Postcode({
        oncomplete: (data) => {
          this.zonecode = data.zonecode;
          this.roadAddress = data.roadAddress;
        }
      }).open()
    },

    async checkDuplicate() {
      if (this.username === '') {
        this.$openModal('alertModal', {
            message: '아이디를 입력해 주세요'
          })
        return;
      }
      if (await this.requestCheckUsername(this.username)) {
        this.$openModal('alertModal', {
            message: '사용 가능한 아이디입니다.'
        })
        this.usernameCheck = true;
      } else {
        this.$openModal('alertModal', {
            message: '중복된 아이디입니다.'
          })
      }
    },

    async signup() {
      const isValid = this.validation()
      if (isValid) {
        this.$openModal('alertModal', {
            message: isValid
          })
        return
      }

      const birthday = this.birthday.year + '-' + this.birthday.month + '-' + this.birthday.day
      const birthdayCalendar = this.birthday.calendar
      const telNum = this.telNum.telFirst + this.telNum.telMiddle + this.telNum.telLast
      const phoneNum = this.phoneNum.phoneFirst + this.phoneNum.phoneMiddle + this.phoneNum.phoneLast
      const email = this.email.emailFirst + '@' + this.email.emailLast
      const marketingSms = this.marketingAgreement.sms
      const marketingEmail = this.marketingAgreement.email
      const {name, username, pwd, zonecode, roadAddress, detailAddress} = this

      if (await this.requestSignup({name, username, pwd, birthday, zonecode, roadAddress, detailAddress, telNum, phoneNum, birthdayCalendar, email, marketingSms, marketingEmail})) {
        this.$emit('nextPage')
      }
    },

    validation() {
      if (this.name.length < 1) return '이름을 입력해 주세요'
      if (this.username.length < 1) return '아이디를 입력해 주세요'
      if (this.pwd.length < 1) return '비밀번호를 입력해주세요'
      if (this.pwdCheck.length < 1) return '비밀번호 확인을 입력해 주세요'
      if (this.pwd != this.pwdCheck) return '비밀번호와 비밀번호 확인이 일치하지 않습니다.'
      if (this.passwordError === "비밀번호 조합 기준에 적합하지 않습니다.") return this.passwordError
      if (this.phoneNum.phoneFirst.length < 1 || this.phoneNum.phoneMiddle.length < 1 || this.phoneNum.phoneLast.length < 1 ) return '휴대폰 번호를 입력해 주세요'
      if (this.telNum.telFirst.length < 1 || this.telNum.telMiddle.length < 1 || this.telNum.telLast.length < 1 ) return '전화 번호를 입력해 주세요'
      if (!this.verified) return '본인인증을 완료해주세요'
      if (this.email.emailFirst.length < 1 || this.email.emailLast.length < 1) return '이메일을 입력해 주세요'
      if (!this.usernameCheck) return '아이디 중복을 확인해주세요'
      else return ''
    },

    toggleRadio(type) {
      if (this.marketing[type] === 'Y') {
        this.marketing[type] = 'N';
      } else {
        this.marketing[type] = 'Y';
      }
    },

    validatePassword() {
      const passwordRule = /^(?=.*[A-Za-z])(?=.*\d|.*[\W_])[A-Za-z\d\W_]{8,16}$/;
      if (!passwordRule.test(this.pwd)) {
        this.passwordError = "비밀번호 조합 기준에 적합하지 않습니다.";
      } else {
        this.passwordError = "사용가능한 비밀번호입니다.";
      }
    },

    vertifyPhone () {
        const fullPhone = `${this.phoneNum.phoneFirst}${this.phoneNum.phoneMiddle}${this.phoneNum.phoneLast}`;
        const fullName = this.name;

        if (fullPhone.length < 10 || !fullName) {
            this.$openModal('alertModal', {
                message: "이름과 전화번호를 정확히 입력해주세요."
            })
            return;
        }

        PortOne.requestIdentityVerification({
            storeId: env.api.STORE_ID,
            identityVerificationId: `identity-verification-${crypto.randomUUID()}`,
            channelKey: env.api.DANAL_CHANNEL_KEY,
            customer: {
                phoneNumber: fullPhone,
                fullName: fullName,
            },
        }).then(async (result) => {
            if (result.code !== undefined) {
                this.$openModal('alertModal', {
                    message: "본인인증 실패: " + result.message
                })
                return;
            }

            this.verified = true;
            this.$openModal('alertModal', {
                message: "본인인증 완료!"
            })
        }).catch((err) => {
            console.error("본인인증 중 예외:", err);
            this.$openModal('alertModal', {
                message: "인증 도중 오류가 발생했습니다."
            })
        });
    }
  },

  watch: {
    emailSelf: {
        handler(newVal) {
            if (newVal !== '직접입력') {
                this.email.emailLast = newVal
            } else {
                this.email.emailLast = ''
            }
        }
    },

    username: {
        handler() {
            this.usernameCheck = false
        }
    }
  },

  

}
</script>
<style lang="">

</style>